<template>
    <div class="text-white settings">
        <b-button class="settings-button" v-b-modal.settings-modal><icon name="cog"></icon></b-button>
        <b-modal id="settings-modal" title="Настройки" hide-footer centered>
          <div class="">
            <b-badge>Общая информация:</b-badge>
            <div>
              <span v-if="userName">ФИО Сотрудника: {{userName}}.</span>
            </div>
            <div>
              <span v-if="pageName">Страница: {{pageName}}.</span>
            </div>
          </div>
          <b-form-group class="mb-0" v-if="userRole === USER_ROLE_CALL_CENTER">
            <b-badge>Настройки:</b-badge>
            <b-form-checkbox name="callCenterWindowCheckBox" v-model="showWindow" switch>Показывать список заказов</b-form-checkbox>
          </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import {
  USER_ROLE_CALL_CENTER,
  USER_ROLE_COLD_COOKER,
  USER_ROLE_COLD_CUTTER,
  USER_ROLE_COLLECTOR,
  USER_ROLE_DELIVERY_COURIER,
  USER_ROLE_HOT_COOKER,
  USER_ROLE_LOGISTICIAN,
  USER_ROLE_PIZZA_COLLECTOR,
  USER_ROLE_PIZZA_COOKER,
  USER_ROLE_PIZZA_DOUGH,
  USER_ROLE_ADMIN
} from '../constants/roles'

export default {
  name: 'WorkerAction',
  data () {
    return {
      showWindow: true,
      USER_ROLE_CALL_CENTER,
      items: [
        { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
        { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
        { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
        { age: 38, first_name: 'Jami', last_name: 'Carney' }
      ]
    }
  },
  methods: {},
  watch: {
    showWindow (newVal) {
      this.$emit('showOrHideOrdersWindow', newVal)
    }
  },
  computed: {
    pageName () {
      if (this.$userControl.jwtParsed) {
        switch (this.$userControl.jwtParsed.role) {
          case USER_ROLE_CALL_CENTER:
            return 'Колл-центр'
          case USER_ROLE_LOGISTICIAN:
            return 'Логистика'
          case USER_ROLE_COLLECTOR:
            return 'Сборка заказов'
          case USER_ROLE_COLD_COOKER:
            return 'Приготовление роллов'
          case USER_ROLE_COLD_CUTTER:
            return 'Нарезка роллов'
          case USER_ROLE_HOT_COOKER:
            return 'Горячий цех'
          case USER_ROLE_PIZZA_DOUGH:
            return 'Расскатка пиццы'
          case USER_ROLE_PIZZA_COOKER:
            return 'Начинение пиццы'
          case USER_ROLE_PIZZA_COLLECTOR:
            return 'Сборка пиццы'
          case USER_ROLE_DELIVERY_COURIER:
            return 'Курьерская служба'
          case USER_ROLE_ADMIN:
            return 'Статистика'
        }
      }
      return ''
    },
    userName () {
      if (this.$userControl.jwtParsed) {
        let nameParts = String(this.$userControl.jwtParsed.name).split('.')
        nameParts = nameParts.map((x) => { return x.trim() }).filter(x => x !== '')
        return nameParts.join('.')
      }
    },
    userRole () {
      return this.$userControl.jwtParsed ? this.$userControl.jwtParsed.role : null
    }
  }
}
</script>

<style lang="scss" scoped>
  .settings {
    margin-right: 0.5rem;
    @media (max-width: 640px) {
        margin-right: 0;
    }
    .settings-button {
      @media (max-width: 640px) {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/WorkerAction.vue